<script>
  import Header from "./components/Header.svelte";
  import Footer from "./components/Footer.svelte";
  import DataDeletion from "./routes/DataDeletion.svelte";
</script>

<Header />
<main>
  <DataDeletion />
</main>
<Footer />
